/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Signal_Energy_TitleInputs */

const en_landing_signal_energy_title = /** @type {(inputs: Landing_Signal_Energy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brent breaks $92`)
};

/**
* | output |
* | --- |
* | "Brent breaks $92" |
*
* @param {Landing_Signal_Energy_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_signal_energy_title = /** @type {((inputs?: Landing_Signal_Energy_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Signal_Energy_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_signal_energy_title(inputs)
});